/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { PageLayout } from '@/Client/Layout';
import { FloorPlanEditorDemo } from '@/Client/Partials/FloorPlanEditorDemo';

const DEMO_HOST_STYLE = css`
  label: FLOOR_PLAN_EDITOR_DEMO_PAGE_HOST_STYLE;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

/** The floor plan editors over sample data with in-memory saves, reached from the account menu behind `floorPlanEditorAdvanced`. */
export const FloorPlanEditorDemoPage = () => (
  <PageLayout title='Floor plan editor demo'>
    <div css={DEMO_HOST_STYLE}>
      <FloorPlanEditorDemo />
    </div>
  </PageLayout>
);
